import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import {
  ABONADAS_PENDIENTES_DE_VALIDACION,
  ANULADAS,
  APROBADAS,
  DENEGADAS,
  EN_ESTUDIO,
  FORMALIZADAS_ABONADAS_VALIDADAS,
  PENDIENTES_DE_DATOS,
  PENDIENTES_PAGO_POR_INCIDENCIAS,
  FIRMADAS,
  CONDICIONADA_PENDIENTE_DE_FORMALIZACION,
} from '@app/@core/constants/requests.constants';
import { URL_REQUESTS_LANDING_VIDEOSELFING } from '@app/@core/constants/routes.constants';
import { CommonDataDTO } from '@app/requests/model/combos-model';
import { Operation } from '@app/requests/model/requests-model';
import { PanelStore } from '@app/requests/panel/panel.store';
import { RequestsGetDataApi } from '@app/requests/requests-get-data-service/requests-get-data-api.service';
import { RequestsGetDataStore } from '@app/requests/requests-get-data-service/requests-get-data.store';

@Component({
  selector: 'scf-request-header',
  templateUrl: './request-header.component.html',
  styleUrls: ['./request-header.component.scss'],
})
export class RequestHeaderComponent implements OnInit {
  @Input() numRequest: string;
  @Input() documentation: any[] = [];
  @Input() state: CommonDataDTO;
  @Input() operative: string;
  @Input() operation: Operation;

  stateName: string = '';
  stateClass: string;

  constructor(
    private panelStore: PanelStore,
    private getDataApi: RequestsGetDataApi,
    private getDataStore: RequestsGetDataStore,
    private router: Router
  ) {}

  ngOnInit() {
    this.stateName = this.panelStore.getStatusById(this.state?.id)?.value;
    console.log('State name: ', this.stateName);
    switch (this.state?.id) {
      case PENDIENTES_DE_DATOS:
        this.stateClass = 'pending';
        break;
      case APROBADAS:
        this.stateClass = 'approved';
        break;
      case EN_ESTUDIO:
        this.stateClass = 'study';
        break;
      case DENEGADAS:
        this.stateClass = 'denied';
        break;
      case 'ABONADAS PENDIENTES DE VALIDACION':
        this.stateClass = 'signed';
        break;
      case FORMALIZADAS_ABONADAS_VALIDADAS:
        this.stateClass = 'formalized';
        break;
      case ANULADAS:
        this.stateClass = 'canceled';
        break;
      case PENDIENTES_PAGO_POR_INCIDENCIAS:
        this.stateClass = 'pendingIncidents';
        break;
      case FIRMADAS:
        this.stateClass = 'signed';
        break;
      case CONDICIONADA_PENDIENTE_DE_FORMALIZACION:
        this.stateClass = 'conditionedPending';
        break;
    }
  }

  isEnabledVideoselfing(): boolean {
    return this.operation.digitalId === 'S' || this.operation.digitalId === 'U' || this.operation.digitalId === 'C';
  }
}
